import { appData, commentsData, mediaData } from '@/mocks/51cgHomeData';

export function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          {appData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">{appData.subtitle}</p>

        <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-8 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
              {appData.description}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {appData.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 text-xs">
                    <i className="ri-check-line"></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line"></i>
                iOS 下载
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 hover:border-background-400 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line"></i>
                Android 下载
              </button>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-background-200 border-2 border-background-300/60 flex items-center justify-center">
            <span className="text-5xl text-foreground-300">
              <i className="ri-smartphone-line"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          瓜友热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">来自51cg吃瓜群众的真实声音</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="rounded-2xl bg-background-100 border border-background-200/70 p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-700 text-sm font-bold flex-shrink-0">
                  {comment.avatar}
                </span>
                <div>
                  <span className="block text-sm font-semibold text-foreground-800">{comment.user}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i> {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-accent-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  const mediaItems = [
    {
      id: 'media-1',
      title: '51cg莫里秀：豪门找爹惊天逆转',
      duration: '48:32',
      views: '128.6万',
      tag: '莫里秀',
      image: 'https://readdy.ai/api/search-image?query=TV%20show%20thumbnail%20style%20illustration%20with%20dramatic%20family%20drama%20theme%2C%20silhouettes%20of%20people%20in%20confrontation%2C%20warm%20coral%20and%20deep%20burgundy%20color%20palette%2C%20reality%20TV%20show%20aesthetic%2C%20emotional%20tension%2C%20bold%20text%20overlay%20area&width=640&height=360&seq=51cg-media-1&orientation=landscape',
    },
    {
      id: 'media-2',
      title: '51cg爆料：某顶流背后不为人知的秘密',
      duration: '32:15',
      views: '96.3万',
      tag: '独家爆料',
      image: 'https://readdy.ai/api/search-image?query=Mysterious%20investigative%20journalism%20illustration%2C%20silhouette%20of%20a%20celebrity%20with%20hidden%20documents%20and%20secrets%20revealed%2C%20warm%20terracotta%20and%20cream%20tones%2C%20noir%20inspired%20mood%2C%20exclusive%20scoop%20theme&width=640&height=360&seq=51cg-media-2&orientation=landscape',
    },
    {
      id: 'media-3',
      title: '51cg情感八卦：三对明星夫妻真实相处现状',
      duration: '25:48',
      views: '87.1万',
      tag: '情感八卦',
      image: 'https://readdy.ai/api/search-image?query=Romantic%20relationship%20drama%20illustration%2C%20three%20couples%20silhouettes%20with%20heart%20and%20crack%20motifs%2C%20warm%20rose%20and%20peach%20color%20palette%2C%20tabloid%20magazine%20style%2C%20emotional%20gossip%20theme&width=640&height=360&seq=51cg-media-3&orientation=landscape',
    },
    {
      id: 'media-4',
      title: '51cg黑料合集：2026最轰动的十起塌房事件',
      duration: '55:20',
      views: '156.8万',
      tag: '黑料合集',
      image: 'https://readdy.ai/api/search-image?query=Collapsing%20building%20metaphor%20illustration%2C%20falling%20stars%20and%20crowns%2C%20dramatic%20ruins%20theme%2C%20warm%20amber%20and%20dusty%20rose%20color%20scheme%2C%20scandal%20expose%20aesthetic%2C%20bold%20editorial%20design&width=640&height=360&seq=51cg-media-4&orientation=landscape',
    },
    {
      id: 'media-5',
      title: '51cg.fun专题：网红的流量密码与翻车现场',
      duration: '41:06',
      views: '73.5万',
      tag: '深度专题',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20illustration%20with%20like%20buttons%20and%20alert%20signs%2C%20going%20viral%20versus%20getting%20canceled%20theme%2C%20warm%20coral%20and%20neutral%20beige%20tones%2C%20digital%20culture%20commentary%2C%20trendy%20tech%20aesthetic&width=640&height=360&seq=51cg-media-5&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">51cg在线观看热门视频内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-accent-500 text-xl transition-transform group-hover:scale-110">
                    <i className="ri-play-fill"></i>
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/70 text-white text-xs font-medium">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}